import Vue from 'vue'
import Router from 'vue-router'

// 消除跳转当前路由报警的问题
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch(err => err)
};

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "pages" */ '../../views/pages/Index.vue')
    },
    {
      path: '/home',
      component: () => import(/* webpackChunkName: "pages" */ '../../views/pages/Home.vue')
    },
    {
      path: '/auth',
      component: () => import(/* webpackChunkName: "pages" */ '../../views/pages/auth/Auth.vue')
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
